import { decryptToAsciiString, encryptAsciiStringToHexString } from "../../dataEncryption";
import { collectLog, createEmptyLogsAndVars, dwReportError, recordVariable, } from "../../diagnostics/clientErrors";
const LOCALSTORAGE_KEY = "mpcWalletClientSessionToken";
export const hasSavedClientSessionToken = () => {
    return localStorage.getItem(LOCALSTORAGE_KEY) !== null;
};
export const storeClientSessionToken = async (provider, clientSessionToken) => {
    const encodedClientSessionToken = await encryptAsciiStringToHexString(provider, clientSessionToken);
    localStorage.setItem(LOCALSTORAGE_KEY, encodedClientSessionToken);
};
export const loadClientSessionToken = async (provider) => {
    const logsAndVars = createEmptyLogsAndVars("clientSessionTokenStorage:loadClientSessionToken");
    try {
        const encodedClientSessionToken = localStorage.getItem(LOCALSTORAGE_KEY);
        recordVariable(logsAndVars, "encodedClientSessionToken from localStorage", encodedClientSessionToken);
        if (encodedClientSessionToken === null) {
            return null;
        }
        else {
            collectLog(logsAndVars, "Trying to decrypt client session token");
            return await decryptToAsciiString(provider, encodedClientSessionToken);
        }
    }
    catch (error) {
        dwReportError(null, undefined, error, { logsAndVars });
        // if not understandable, returning null as if there was none
        return null;
    }
};
export const deleteClientSessionToken = async () => {
    localStorage.removeItem(LOCALSTORAGE_KEY);
};
